import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { LoadingStatus } from '../constants/redux.constants';
import { ProfileNetwork } from '../network/profile';


// Детали пользователя для профиля
export const getProfile = createAsyncThunk(
  'profile/getProfile',
  async () => {
    const result = await ProfileNetwork.getProfile();
    return result;
  }
);


// Список устройств пользователя
export const getProfileDevice = createAsyncThunk(
  'profile/getProfileDevice',
  async () => {
    const result = await ProfileNetwork.getProfileDevice();
    return result;
  }
);


// Список устройств пользователя
export const deleteProfileDevice = createAsyncThunk(
  'profile/deleteProfileDevice',
  async ({ token_id, params }) => {
    const result = await ProfileNetwork.deleteProfileDevice(token_id, params);
    return result;
  }
);


// Список документов пользователя
export const getProfileDocuments = createAsyncThunk(
  'profile/getProfileDocuments',
  async (params) => {
    const result = await ProfileNetwork.getProfileDocuments(params);
    return result;
  }
);

// Отправить запрос на создание ИИ-отчета
export const postCreateAiReport = createAsyncThunk(
  'profile/postCreateAiReport',
  async (params) => {
    const result = await ProfileNetwork.postCreateAiReport(params);
    return result;
  }
);

// Создать обращение в поддержку
export const postSupportMessage = createAsyncThunk(
  'profile/postSupportMessage',
  async (params) => {
    const result = await ProfileNetwork.postSupportMessage(params);
    return result;
  }
);


// Изменение профиля юзера
export const postProfileUpdate = createAsyncThunk(
  'profile/postProfileUpdate',
  async (params) => {
    const result = await ProfileNetwork.postProfileUpdate(params);
    return result;
  }
);


const initialState = {
  // Профиль пользователя
  profile:                [],
  profileLS:              LoadingStatus.IDLE,

  // Список устройтв
  deviceList:             [],
  deviceListLS:           LoadingStatus.IDLE,

  // Удаление девайса
  deleteDeviceLS:         LoadingStatus.IDLE,

  // Изменение профиля юзера
  updateProfileLS:        LoadingStatus.IDLE,

  // Список документов
  documentList:           [],
  documentListLS:         LoadingStatus.IDLE,

  // Создать ИИ-отчет
  createAiReportLS:       LoadingStatus.IDLE,

  // Создать обращение в поддержку
  postSupportMessageLS:   LoadingStatus.IDLE 
}


export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
      clearDeviceList(state) {
        state.deviceList              = initialState.deviceList;
        state.deviceListLS            = initialState.deviceListLS;
      },
      clearDocumentList(state) {
        state.documentList            = initialState.documentList;
        state.documentListLS          = initialState.documentListLS;
      },
      clearDeleteDeviceLS(state) {
        state.deleteDeviceLS          = initialState.deleteDeviceLS;
      },
      clearPostSupportMessageLS(state) {
        state.postSupportMessageLS    = initialState.postSupportMessageLS;
      },
      clearUpdateProfileLS(state) {
        state.updateProfileLS    = initialState.updateProfileLS;
      },
      clearCreateAiReportLS(state) {
        state.createAiReportLS = initialState.createAiReportLS;
      }
    },
    extraReducers: (builder) => {
      // Профиль пользователя
      builder.addCase(getProfile.pending, (state) => {
        state.profileLS     = LoadingStatus.PENDING;
      })

      builder.addCase(getProfile.fulfilled, (state, action) => {
        state.profile       = action.payload;
        state.profileLS     = LoadingStatus.SUCCEEDED;
      })

      builder.addCase(getProfile.rejected, (state) => {
        state.profileLS     = LoadingStatus.FAILED;
      });

      // Список устройтв
      builder.addCase(getProfileDevice.pending, (state) => {
        state.deviceListLS  = LoadingStatus.PENDING;
      })

      builder.addCase(getProfileDevice.fulfilled, (state, action) => {
        state.deviceList    = action.payload;
        state.deviceListLS  = LoadingStatus.SUCCEEDED;
      })

      builder.addCase(getProfileDevice.rejected, (state) => {
        state.deviceListLS  = LoadingStatus.FAILED;
      });

      // Удаление девайса
      builder.addCase(deleteProfileDevice.pending, (state) => {
        state.deleteDeviceLS  = LoadingStatus.PENDING;
      })

      builder.addCase(deleteProfileDevice.fulfilled, (state, action) => {
        state.deleteDeviceLS  = LoadingStatus.SUCCEEDED;
      })

      builder.addCase(deleteProfileDevice.rejected, (state) => {
        state.deleteDeviceLS  = LoadingStatus.FAILED;
      });

      // Изменение профиля юзера
      builder.addCase(postProfileUpdate.pending, (state) => {
        state.updateProfileLS  = LoadingStatus.PENDING;
      })

      builder.addCase(postProfileUpdate.fulfilled, (state, action) => {
        state.updateProfileLS  = LoadingStatus.SUCCEEDED;
      })

      builder.addCase(postProfileUpdate.rejected, (state) => {
        state.updateProfileLS  = LoadingStatus.FAILED;
      });

      // Список документов
      builder.addCase(getProfileDocuments.pending, (state) => {
        state.documentListLS  = LoadingStatus.PENDING;
      })

      builder.addCase(getProfileDocuments.fulfilled, (state, action) => {
        state.documentList    = action.payload;
        state.documentListLS  = LoadingStatus.SUCCEEDED;
      })

      builder.addCase(getProfileDocuments.rejected, (state) => {
        state.documentListLS  = LoadingStatus.FAILED;
      });

      // Создать ИИ-отчет
      builder.addCase(postCreateAiReport.pending, (state) => {
        state.createAiReportLS  = LoadingStatus.PENDING;
      });

      builder.addCase(postCreateAiReport.fulfilled, (state, action) => {
        state.createAiReportLS  = LoadingStatus.SUCCEEDED;
      });

      builder.addCase(postCreateAiReport.rejected, (state) => {
        state.createAiReportLS  = LoadingStatus.FAILED;
      });

      // Создать обращение в поддержку
      builder.addCase(postSupportMessage.pending, (state) => {
        state.postSupportMessageLS  = LoadingStatus.PENDING;
      })

      builder.addCase(postSupportMessage.fulfilled, (state, action) => {
        state.postSupportMessageLS  = LoadingStatus.SUCCEEDED;
      })

      builder.addCase(postSupportMessage.rejected, (state) => {
        state.postSupportMessageLS  = LoadingStatus.FAILED;
      });
    }
});


export const { clearDeviceList, clearDocumentList, clearDeleteDeviceLS, clearPostSupportMessageLS, clearUpdateProfileLS, clearCreateAiReportLS } = profileSlice.actions;

export default profileSlice.reducer;